import { toast } from "react-toastify";
import moment from "moment";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
import DanhSachNhomQuyenApi from "service/HeThongNT/DanhSachNhomQuyenApi";

export function utils(msg, type, position, duration) { }
export function parseNumber(
  value,
  { thousandSeparator = ".", decimalSeparator = "," } = {}
) {
  if (typeof value !== "string") return NaN;

  let result = value.trim();

  // Bỏ dấu phân tách hàng nghìn
  if (thousandSeparator) {
    const regex = new RegExp(`\\${thousandSeparator}`, "g");
    result = result.replace(regex, "");
  }

  // Đổi dấu phân cách thập phân về dấu "."
  if (decimalSeparator && decimalSeparator !== ".") {
    const regex = new RegExp(`\\${decimalSeparator}`, "g");
    result = result.replace(regex, ".");
  }

  return Number(result);
}

export function utilsOnChangeSelectTypeDate(state) {
  if (state.typeDate == "0") {
    state.tuNgay = moment().add(-36500, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(36500, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "1") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.tuNgay = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tuNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denNgay = moment(state.denNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).add(-3, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay, "YYYY-MM-DD").format("YYYY-01-01");
  }
  return state;
}
export function utilsOnChangeSelectTypeDateMain(state) {
  if (state.typeDate == "0") {
    state.tuNgay = moment().add(-36500, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(36500, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "1") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.tuNgay = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tuNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denNgay = moment(state.denNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).add(-2, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay, "YYYY-MM-DD").format("YYYY-01-01");
  } else if (state.typeDate == "11") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().format("YYYY-MM-DD");
  }
  return state;
}
export function utilsOnChangeSelectTypeDateMainTuanDh(state) {
  if (state.typeDate == "0") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "1") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.tuNgay = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.tuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tuNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denNgay = moment(state.denNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.tuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.tuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay).add(-3, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.tuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgay = moment(state.tuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgay = moment(state.denNgay, "YYYY-MM-DD").format("YYYY-01-01");
  } else if (state.typeDate == "11") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().format("YYYY-MM-DD");
  }
  return state;
}
export function utilsOnChangeSelectTypeDateMainNew(state) {
  if (state.typeDate == "1") {
    state.fromDate = moment().format("YYYY-MM-DD");
    state.toDate = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.fromDate = moment().add(-1, "days").format("YYYY-MM-DD");
    state.toDate = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.fromDate = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.toDate = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.fromDate = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.toDate = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.fromDate = moment(state.fromDate, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.toDate = moment(state.toDate, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.fromDate = moment().startOf("month").format("YYYY-MM-DD");
    state.toDate = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.fromDate = moment().startOf("month").format("YYYY-MM-DD");
    state.toDate = moment().endOf("month").format("YYYY-MM-DD");
    state.toDate = moment(state.fromDate, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.fromDate = moment(state.toDate).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.fromDate = moment().startOf("quarter").format("YYYY-MM-DD");
    state.toDate = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.fromDate = moment().startOf("quarter").format("YYYY-MM-DD");
    state.toDate = moment().endOf("quarter").format("YYYY-MM-DD");
    state.toDate = moment(state.fromDate, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.fromDate = moment(state.toDate).add(-3, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.fromDate = moment().startOf("year").format("YYYY-MM-DD");
    state.toDate = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.fromDate = moment().startOf("year").format("YYYY-MM-DD");
    state.toDate = moment().endOf("year").format("YYYY-MM-DD");
    state.toDate = moment(state.fromDate, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.fromDate = moment(state.toDate, "YYYY-MM-DD").format("YYYY-01-01");
  } else if (state.typeDate == "11") {
    state.fromDate = moment().format("YYYY-MM-DD");
    state.toDate = moment().format("YYYY-MM-DD");
  }
  return state;
}

export function utilsOnChangeSelectTypeDateNewDate(state) {
  if (state.typeDate == "1") {
    state.TuNgay = moment().format("YYYY-MM-DD");
    state.DenNgay = moment().add(1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.TuNgay = moment().add(-1, "days").format("YYYY-MM-DD");
    state.DenNgay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.TuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.DenNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.TuNgay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.DenNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.TuNgay = moment(state.TuNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.DenNgay = moment(state.DenNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.TuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.TuNgay = moment().startOf("month").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("month").format("YYYY-MM-DD");
    state.DenNgay = moment(state.TuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.TuNgay = moment(state.DenNgay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.TuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.TuNgay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.DenNgay = moment(state.TuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.TuNgay = moment(state.DenNgay).add(-3, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.TuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.TuNgay = moment().startOf("year").format("YYYY-MM-DD");
    state.DenNgay = moment().endOf("year").format("YYYY-MM-DD");
    state.DenNgay = moment(state.TuNgay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.TuNgay = moment(state.DenNgay, "YYYY-MM-DD").format("YYYY-01-01");
  }
  return state;
}

export function utilsOnChangeSelectTypeDateNew(state) {
  if (state.typeDate == "0") {
    state.tuNgay = moment().add(-36500, "days").format("YYYY-MM-DD");
    state.denNgay = moment().add(36500, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "1") {
    state.tuNgay = moment().format("1991-01-01");
    state.denNgay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.tuNgay = moment().add(-1, "days").format("1991-01-01");
    state.denNgay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.tuNgay = moment().clone().weekday(0).format("1991-01-01");
    state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.tuNgay = moment().clone().weekday(0).format("1991-01-01");
    // state.denNgay = moment().clone().weekday(6).format("YYYY-MM-DD");
    // state.tuNgay = moment(state.tuNgay, "YYYY-MM-DD")
    //   .add(-7, "days")
    //   .format("YYYY-MM-DD");
    state.denNgay = moment(state.denNgay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.tuNgay = moment().startOf("month").format("1991-01-01");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.tuNgay = moment().startOf("month").format("1991-01-01");
    state.denNgay = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgay = moment(
      moment().startOf("month").format("YYYY-MM-DD"),
      "YYYY-MM-DD"
    )
      .add(-1, "days")
      .format("YYYY-MM-DD");
    // state.tuNgay = moment(state.denNgay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.tuNgay = moment().startOf("quarter").format("1991-01-01");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.tuNgay = moment().startOf("quarter").format("1991-01-01");
    state.denNgay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgay = moment(
      moment().startOf("quarter").format("YYYY-MM-DD"),
      "YYYY-MM-DD"
    )
      .add(-1, "days")
      .format("YYYY-MM-DD");
    // state.tuNgay = moment(state.denNgay).add(-3, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.tuNgay = moment().startOf("year").format("1991-01-01");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.tuNgay = moment().startOf("year").format("1991-01-01");
    state.denNgay = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgay = moment(
      moment().startOf("year").format("YYYY-MM-DD"),
      "YYYY-MM-DD"
    )
      .add(-1, "days")
      .format("YYYY-MM-DD");
    // state.tuNgay = moment(state.denNgay, "YYYY-MM-DD").format("YYYY-01-01");
  } else if (state.typeDate == "11") {
    state.tuNgay = moment().format("YYYY-MM-DD");
    state.denNgay = moment().format("YYYY-MM-DD");
  }
  return state;
}

export function utilsOnChangeSelectTypeDateNewXuatHoaDon(state) {
  if (state.typeDateOrder == "1") {
    state.tuNgayOrder = moment().format("YYYY-MM-DD");
    state.denNgayOrder = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "2") {
    state.tuNgayOrder = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denNgayOrder = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "3") {
    state.tuNgayOrder = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgayOrder = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "4") {
    state.tuNgayOrder = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgayOrder = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tuNgayOrder = moment(state.tuNgayOrder, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denNgayOrder = moment(state.denNgayOrder, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "5") {
    state.tuNgayOrder = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "6") {
    state.tuNgayOrder = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgayOrder = moment(state.tuNgayOrder, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrder = moment(state.denNgayOrder).format("YYYY-MM-01");
  } else if (state.typeDateOrder == "7") {
    state.tuNgayOrder = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "8") {
    state.tuNgayOrder = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrder = moment(state.tuNgayOrder, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrder = moment(state.denNgayOrder)
      .add(-3, "month")
      .format("YYYY-MM-01");
  } else if (state.typeDateOrder == "9") {
    state.tuNgayOrder = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDateOrder == "10") {
    state.tuNgayOrder = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgayOrder = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgayOrder = moment(state.tuNgayOrder, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrder = moment(state.denNgayOrder, "YYYY-MM-DD").format(
      "YYYY-01-01"
    );
  } else if (state.typeDateOrder == "11") {
    state.tuNgayOrder = moment().format("YYYY-MM-DD");
    state.denNgayOrder = moment().format("YYYY-MM-DD");
  }

  if (state.typeDateOrderExport == "1") {
    state.tuNgayOrderExport = moment().format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "2") {
    state.tuNgayOrderExport = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "3") {
    state.tuNgayOrderExport = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "4") {
    state.tuNgayOrderExport = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tuNgayOrderExport = moment(state.tuNgayOrderExport, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denNgayOrderExport = moment(state.denNgayOrderExport, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "5") {
    state.tuNgayOrderExport = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "6") {
    state.tuNgayOrderExport = moment().startOf("month").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("month").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment(state.tuNgayOrderExport, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrderExport = moment(state.denNgayOrderExport).format(
      "YYYY-MM-01"
    );
  } else if (state.typeDateOrderExport == "7") {
    state.tuNgayOrderExport = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "8") {
    state.tuNgayOrderExport = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment(state.tuNgayOrderExport, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrderExport = moment(state.denNgayOrderExport)
      .add(-3, "month")
      .format("YYYY-MM-01");
  } else if (state.typeDateOrderExport == "9") {
    state.tuNgayOrderExport = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "10") {
    state.tuNgayOrderExport = moment().startOf("year").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().endOf("year").format("YYYY-MM-DD");
    state.denNgayOrderExport = moment(state.tuNgayOrderExport, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tuNgayOrderExport = moment(
      state.denNgayOrderExport,
      "YYYY-MM-DD"
    ).format("YYYY-01-01");
  } else if (state.typeDateOrderExport == "11") {
    state.denNgayOrderExport = moment().format("YYYY-MM-DD");
    state.denNgayOrderExport = moment().format("YYYY-MM-DD");
  } else if (state.typeDateOrderExport == "-1") {
    state.tuNgayOrderExport = null;
    state.denNgayOrderExport = null;
  }
  return state;
}

export function getDomain() {
  var url = window.location.host;
  var arr = url.split(".")[0];
  if (arr != "localhost") {
    if (arr.indexOf("www") > 0) {
      arr = url.split(".")[1];
    }
  } else {
    arr = "";
  }
  var urlNew = "";
  var urlAPI = window.endPoint;
  if (url.indexOf("192.168") > -1 || url.indexOf("localhost") > -1) {
    urlAPI = window.endPoint;
  } else {
    if (typeof window.endPointUrl === "undefined" || window.endPointUrl == "") {
      urlAPI = window.endPoint;
    } else {
      urlAPI = window.endPointUrl;
    }
  }
  if (arr != "") {
    urlNew = urlAPI.replace("[domain]", arr + ".");
  } else {
    urlNew = urlAPI.replace("[domain]", "");
  }
  return urlNew;
}

export function getDomainNew() {
  var url = window.location.host;
  var arr = url.split(".")[0];

  // Nếu không phải localhost
  if (arr !== "localhost") {
    if (arr.indexOf("www") > 0) {
      arr = url.split(".")[1];
    }
  } else {
    arr = "";
  }

  // Luôn ưu tiên sử dụng endPointNew
  var urlNew = "";
  var urlAPI = window.endPointNew;

  // Kiểm tra và thay thế [domain]
  if (arr !== "") {
    urlNew = urlAPI.replace("[domain]", arr + ".");
  } else {
    urlNew = urlAPI.replace("[domain]", "");
  }

  return urlNew;
}

export function getDomainBackUp() {
  var url = window.location.host;
  var arr = url.split(".")[0];

  // Nếu không phải localhost
  if (arr !== "localhost") {
    if (arr.indexOf("www") > 0) {
      arr = url.split(".")[1];
    }
  } else {
    arr = "";
  }

  // Luôn ưu tiên sử dụng endPointNew
  var urlNew = "";
  var urlAPI = window.endPointBackup;

  // Kiểm tra và thay thế [domain]
  if (arr !== "") {
    urlNew = urlAPI.replace("[domain]", arr + ".");
  } else {
    urlNew = urlAPI.replace("[domain]", "");
  }

  return urlNew;
}
export function getDomainUrlDemo() {
  var url = window.location.host;
  var arr = url.split(".")[0];

  // Nếu không phải localhost
  if (arr !== "localhost") {
    if (arr.indexOf("www") > 0) {
      arr = url.split(".")[1];
    }
  } else {
    arr = "";
  }

  // Luôn ưu tiên sử dụng endPointNew
  var urlNew = "";
  var urlAPI = window.endPointUrlDemo;

  // Kiểm tra và thay thế [domain]
  if (arr !== "") {
    urlNew = urlAPI.replace("[domain]", arr + ".");
  } else {
    urlNew = urlAPI.replace("[domain]", "");
  }

  return urlNew;
}
export function getUrl() {
  var url = window.location.origin;
  if (url.indexOf(window.PortReactjs)) {
    return url.replace(window.PortReactjs, window.PortASP);
  }
  return url;
}

export function getPhienBan() {
  const cookies = new Cookies();
  var phienBan = cookies.get("PhienBan");
  if (typeof phienBan != "undefined" && phienBan != "") {
    return phienBan;
  }
  return "";
}
export function getUserLogin() {
  var objUserLogin = {};
  const cookies = new Cookies();
  var token = cookies.get("userDaiLy");
  if (typeof token != "undefined" && token.length > 6) {
    var arrToken = token.split("|");
    if (arrToken.length > 0) {
      objUserLogin.UserName = arrToken[0];
    }
    if (arrToken.length > 1) {
      objUserLogin.FullName = arrToken[1];
    }
  }
  return objUserLogin;
}
export function CloseModal(handler) {
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      handler(); // Gọi hàm handler khi nhấn phím Escape
    }
  };
  return {
    addListener: () => document.addEventListener("keydown", handleEscape),
    removeListener: () => document.removeEventListener("keydown", handleEscape),
  };
}
// Kiểm tra quyền sửa giá
export function CheckQuyenSuaGia() {
  const cacheKey = "checkQuyenSuaGia";
  const cookies = new Cookies();
  var userToken = cookies.get("userTokenDaiLy");
  const cachedData = sessionStorage.getItem(cacheKey);
  if (cachedData) {
    return JSON.parse(cachedData);
  }

  const xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    `${getDomain()}Role/checkSuaGia?sUserName=${getUserLogin().UserName}`,
    false
  );
  xhr.setRequestHeader("Authorization", userToken.substring(6))
  xhr.send();

  if (xhr.status === 200) {
    try {
      const response = JSON.parse(xhr.responseText);
      sessionStorage.setItem(cacheKey, JSON.stringify(response)); // Lưu vào sessionStorage
      return response;
    } catch (error) {
      console.error("Lỗi phân tích phản hồi từ API:", error);
    }
  }

  return true;
}
// 📌 Hàm lấy cấu hình định dạng số
export function GetNumberFormatConfig() {
  const cookies = new Cookies();
  var userToken = cookies.get("userTokenDaiLy");
  const cacheKey = "numberFormatConfig";
  const cachedData = localStorage.getItem(cacheKey);

  // Nếu có cache rồi thì dùng luôn (đỡ tốn request)
  if (cachedData) {
    return JSON.parse(cachedData);
  }

  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `${getDomain()}Role/getNumberFormat`, false);
    xhr.setRequestHeader("Authorization", userToken.substring(6))
    xhr.send();

    if (xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);

      // Lưu cache để lần sau khỏi gọi API nữa
      localStorage.setItem(cacheKey, JSON.stringify(response));

      return response;
    }
  } catch (error) {
    console.error("Lỗi lấy cấu hình number format:", error);
  }

  // fallback mặc định (nếu API lỗi)
  return {
    decimalSeparator: ",",
    thousandSeparator: ".",
    decimalScale: 3,
    allowTrailingZeros: true,
  };
}
// export function getBranch() {
//   const cookies = new Cookies();
//   var token = cookies.get("ChiNhanh");
//   if (typeof token != "undefined" && token != "" && token != "undefined") {
//     return token;
//   }
//   return 1;
// }
export function getBranch() {
  return 1;
}
export function setBranch(iBranch) {
  const cookies = new Cookies();
  cookies.set("ChiNhanh", iBranch, { path: "/" });
}
var ChuSo = new Array(
  " không ",
  " một ",
  " hai ",
  " ba ",
  " bốn ",
  " năm ",
  " sáu ",
  " bảy ",
  " tám ",
  " chín "
);
var Tien = new Array("", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ");
//1. Hàm đọc số có ba chữ số;
export function DocSo3ChuSo(baso) {
  var tram;
  var chuc;
  var donvi;
  var KetQua = "";
  tram = parseInt(baso / 100);
  chuc = parseInt((baso % 100) / 10);
  donvi = baso % 10;
  if (tram == 0 && chuc == 0 && donvi == 0) return "";
  if (tram != 0) {
    KetQua += ChuSo[tram] + " trăm ";
    if (chuc == 0 && donvi != 0) KetQua += " linh ";
  }
  if (chuc != 0 && chuc != 1) {
    KetQua += ChuSo[chuc] + " mươi";
    if (chuc == 0 && donvi != 0) KetQua = KetQua + " linh ";
  }
  if (chuc == 1) KetQua += " mười ";
  switch (donvi) {
    case 1:
      if (chuc != 0 && chuc != 1) {
        KetQua += " mốt ";
      } else {
        KetQua += ChuSo[donvi];
      }
      break;
    case 5:
      if (chuc == 0) {
        KetQua += ChuSo[donvi];
      } else {
        KetQua += " lăm ";
      }
      break;
    default:
      if (donvi != 0) {
        KetQua += ChuSo[donvi];
      }
      break;
  }
  return KetQua;
}

//2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
export function DocTienBangChu(SoTien) {
  var lan = 0;
  var i = 0;
  var so = 0;
  var KetQua = "";
  var tmp = "";
  var ViTri = new Array();
  if (SoTien < 0) return "Số tiền âm !";
  if (SoTien == 0) return "Không đồng !";
  if (SoTien > 0) {
    so = SoTien;
  } else {
    so = -SoTien;
  }
  if (SoTien > 8999999999999999) {
    //SoTien = 0;
    return "Số quá lớn!";
  }
  ViTri[5] = Math.floor(so / 1000000000000000);
  if (isNaN(ViTri[5])) ViTri[5] = "0";
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
  ViTri[4] = Math.floor(so / 1000000000000);
  if (isNaN(ViTri[4])) ViTri[4] = "0";
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
  ViTri[3] = Math.floor(so / 1000000000);
  if (isNaN(ViTri[3])) ViTri[3] = "0";
  so = so - parseFloat(ViTri[3].toString()) * 1000000000;
  ViTri[2] = parseInt(so / 1000000);
  if (isNaN(ViTri[2])) ViTri[2] = "0";
  ViTri[1] = parseInt((so % 1000000) / 1000);
  if (isNaN(ViTri[1])) ViTri[1] = "0";
  ViTri[0] = parseInt(so % 1000);
  if (isNaN(ViTri[0])) ViTri[0] = "0";
  if (ViTri[5] > 0) {
    lan = 5;
  } else if (ViTri[4] > 0) {
    lan = 4;
  } else if (ViTri[3] > 0) {
    lan = 3;
  } else if (ViTri[2] > 0) {
    lan = 2;
  } else if (ViTri[1] > 0) {
    lan = 1;
  } else {
    lan = 0;
  }
  for (i = lan; i >= 0; i--) {
    tmp = DocSo3ChuSo(ViTri[i]);
    KetQua += tmp;
    if (ViTri[i] > 0) KetQua += Tien[i];
    // if (i > 0 && tmp.length > 0) KetQua += ",";
  }
  if (KetQua.substring(KetQua.length - 1) == ",") {
    KetQua = KetQua.substring(0, KetQua.length - 1);
  }
  KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2);
  return KetQua + " đồng.";
}

export function CheckTokenReload(response) {
  if (response.status == null && response.data === null) {
    window.location.href = "/DangNhap";
  }
}


export function GetRoleParentCap1ByLink(linkPage, setGetLink) {
  DanhSachNhomQuyenApi.listMenu().then((response) => {
    if (response.data.length > 0) {
      response.data.map((e, i) => {
        if (e.RoleChilds.length > 0) {
          e.RoleChilds.map((ee, ii) => {
            if (ee.RoleChilds.length > 0) {
              ee.RoleChilds.map((eee, iii) => {
                if (eee.Link == linkPage) {
                  var obj = {};
                  obj.Code = e.Code;
                  obj.Name = e.Name;
                  setGetLink(obj);
                }
              });
            }
          });
        }
      });
    }
  });
}
export function CheckVersion() {
  let name = "BanHangReatjs";
  let version = window.Version;
  console.log(`${name} v${version} 😎`);
  const last_version = localStorage.getItem(`${name}-Version`);
  if (last_version !== version) {
    console.log("New Version Available ! 😝");
    localStorage.setItem(`${name}-Version`, version);
    window.location.reload(true);
  }
}

export function LamTronNghin(SoTien, IsLamTron) {
  if (IsLamTron) {
    return Math.round(SoTien / 1000) * 1000;
  }
  return Math.round(SoTien);
}

export function utilsOnChangeSelectTypeDateMain1(state) {
  if (state.typeDate == "0") {
    state.tungay = moment().add(-36500, "days").format("YYYY-MM-DD");
    state.denngay = moment().add(36500, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "1") {
    state.tungay = moment().format("YYYY-MM-DD");
    state.denngay = moment().add(0, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "2") {
    state.tungay = moment().add(-1, "days").format("YYYY-MM-DD");
    state.denngay = moment().add(-1, "days").format("YYYY-MM-DD");
  } else if (state.typeDate == "3") {
    state.tungay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denngay = moment().clone().weekday(6).format("YYYY-MM-DD");
  } else if (state.typeDate == "4") {
    state.tungay = moment().clone().weekday(0).format("YYYY-MM-DD");
    state.denngay = moment().clone().weekday(6).format("YYYY-MM-DD");
    state.tungay = moment(state.tungay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
    state.denngay = moment(state.denngay, "YYYY-MM-DD")
      .add(-7, "days")
      .format("YYYY-MM-DD");
  } else if (state.typeDate == "5") {
    state.tungay = moment().startOf("month").format("YYYY-MM-DD");
    state.denngay = moment().endOf("month").format("YYYY-MM-DD");
  } else if (state.typeDate == "6") {
    state.tungay = moment().startOf("month").format("YYYY-MM-DD");
    state.denngay = moment().endOf("month").format("YYYY-MM-DD");
    state.denngay = moment(state.tungay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tungay = moment(state.denngay).format("YYYY-MM-01");
  } else if (state.typeDate == "7") {
    state.tungay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denngay = moment().endOf("quarter").format("YYYY-MM-DD");
  } else if (state.typeDate == "8") {
    state.tungay = moment().startOf("quarter").format("YYYY-MM-DD");
    state.denngay = moment().endOf("quarter").format("YYYY-MM-DD");
    state.denngay = moment(state.tungay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tungay = moment(state.denngay).add(-2, "month").format("YYYY-MM-01");
  } else if (state.typeDate == "9") {
    state.tungay = moment().startOf("year").format("YYYY-MM-DD");
    state.denngay = moment().endOf("year").format("YYYY-MM-DD");
  } else if (state.typeDate == "10") {
    state.tungay = moment().startOf("year").format("YYYY-MM-DD");
    state.denngay = moment().endOf("year").format("YYYY-MM-DD");
    state.denngay = moment(state.tungay, "YYYY-MM-DD")
      .add(-1, "days")
      .format("YYYY-MM-DD");
    state.tungay = moment(state.denngay, "YYYY-MM-DD").format("YYYY-01-01");
  } else if (state.typeDate == "11") {
    state.tungay = moment().format("YYYY-MM-DD");
    state.denngay = moment().format("YYYY-MM-DD");
  }
  return state;
}

export const timeFromNow = (time) => {
  const now = moment();
  const inputTime = moment(time);

  // Số phút chênh lệch
  const diffMinutes = now.diff(inputTime, "minutes");
  const diffHours = now.diff(inputTime, "hours");
  const diffDays = now.diff(inputTime, "days");

  if (diffMinutes < 1) {
    return "Vừa xong";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} phút trước`;
  } else if (diffHours < 24) {
    return `${diffHours} giờ trước`;
  } else if (diffDays < 7) {
    return `${diffDays} ngày trước`;
  } else {
    return inputTime.format("DD/MM/YYYY");
  }
};
